import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38706cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid m-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay d-none d-lg-block" }, null, -1))
const _hoisted_3 = { class: "row d-flex align-items-center vh-sm-100" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "navbar-brand navbar-brand-white" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-lg-6 d-flex justify-content-center align-items-center vh-sm-10" }
const _hoisted_7 = { class: "w-75 py5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Thinking of transferring from your scheme?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.backgroundStyle),
        class: "col-lg-6 vh-sm-100 background-image d-flex p-5 align-items-stretch"
      }, _hoisted_5, 4),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_ctx.startText), 1),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulletPoints, (bulletPoint, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(bulletPoint), 1))
            }), 128))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mt-4",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNextClicked && _ctx.onNextClicked(...args)))
          }, " Get Started ")
        ])
      ])
    ])
  ]))
}